import React, { useEffect } from "react";
import "./Banner-Management.scss";
import useButtonLoader from "hooks/useButtonLoader";
import { CustomModal } from "components/modals/ModalBox";
import { useState } from "react";
import imgUploadToCloudFun from "components/modals/imgUploadAndGetUrl";
import { ImagePreview } from "utils/imagePreviewURLConverter";
import {
  editBannerApi,
  getSelectedBanner,
} from "services/banner-management";

const getBannerImagePayload = (image) => {
  if (!image || typeof image !== "string") {
    return image || "";
  }

  let imagePayload = image.trim();

  while (/^https?:\/\//i.test(imagePayload)) {
    try {
      const imageUrl = new URL(imagePayload);
      imagePayload = decodeURIComponent(imageUrl.pathname).replace(/^\/+/, "");
    } catch (error) {
      break;
    }
  }

  return imagePayload;
};

const EditBanner = ({
  editBannerState,
  bannerMgmtApiCall,
  closeModel,
  position,
  selectedBanner,
  total,
}) => {
  const [error, setError] = useState({});
  const [buttonLoader, setButtonLoader] = useButtonLoader("Add");

  const [imgInputState, setImageInputState] = useState("");
  const [imgPreviewState, seImgPreviewState] = useState(null);
  const [selectedPosition, setSelectedPosition] = useState("");
  const [currentSequence, setCurrentSequence] = useState("");

  const totalSequences = Math.max(
    Number(total) || 0,
    Number(currentSequence) || 0
  );
  const sequenceOptions = Array.from(
    { length: totalSequences },
    (_, i) => i + 1
  ).filter((sequence) => sequence !== Number(currentSequence));

  // -------Validation
  const validation = () => {
    let status = true;
    let errorObject = {};

    if (!imgInputState.length) {
      errorObject["imgEmptyErrorMsg"] = "Image is not Set";
      status = false;
    }

    if (!selectedPosition) {
      errorObject["positionError"] = "Please select a sequence";
      status = false;
    }

    setError(errorObject);
    return status;
  };

  // -------Close Modal
  const addBrandCloseModal = () => {
    setImageInputState("");
    setSelectedPosition("");
    setCurrentSequence("");
    seImgPreviewState(null);
    setError({});
    bannerMgmtApiCall();
    closeModel();
  };

  // -------Submit Handler
  const addBannerHandler = async (e) => {
    e.preventDefault();

    if (validation()) {
      setButtonLoader(true);
      try {
        const dataToSend = {
          image: imgInputState,
          selectedBanner,
          // position,
          sequence: selectedPosition,
        };

        const { data } = await editBannerApi(dataToSend);
        if (data.status || data.code === 200) {
          addBrandCloseModal();
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  // -------Image Upload
  const imgUploadFunction = async (e) => {
    if (!e?.target?.files[0]?.type.includes("image/")) {
      setError((stateProp) => ({
        ...stateProp,
        imgErrorOccur: "Please Choose Image file not others",
      }));
    } else {
      try {
        const data = await imgUploadToCloudFun(e?.target?.files[0]);
        if (data?.status === 200) {
          setImageInputState(getBannerImagePayload(data?.data[0]));
          seImgPreviewState(e?.target?.files[0]);
          setError((stateProp) => ({
            ...stateProp,
            imgEmptyErrorMsg: "",
            imgErrorOccur: "",
          }));
        }
      } catch (error) {
        console.log("error while uploading and getting data", error);
      }
    }
  };

  useEffect(() => {
    // -------Fetch Selected Banner Data
    const fetchSelectedBannerData = async () => {
      try {
        const {
          data: { status, code, data },
        } = await getSelectedBanner(selectedBanner);

        if (status || code === 200) {
          seImgPreviewState(data?.image);
          setImageInputState(getBannerImagePayload(data?.image));
          setCurrentSequence(data?.sequence || "");
        }
      } catch (error) {
        console.log("Error While editing selected Banner", error);
      }
    };

    fetchSelectedBannerData();
  }, [selectedBanner]);

  return (
    <CustomModal
      className={"add_model"}
      show={editBannerState}
      handleClose={addBrandCloseModal}
    >
      <h3>Edit {position} Banner</h3>

      {/* ------Image Upload */}
      <div className="add_model">
        <input
          onChange={imgUploadFunction}
          type="file"
          accept="image/*"
          className="form-control"
        />
      </div>

      {!imgInputState.length && error["imgEmptyErrorMsg"] && (
        <span className="red-color">{error["imgEmptyErrorMsg"]}</span>
      )}
      {error["imgErrorOccur"] && (
        <p className="red-color">{error["imgErrorOccur"]}</p>
      )}

      {/* ------Image Preview */}
      <div className="previewImgContainer">
        <ImagePreview file={imgPreviewState} />
      </div>

      {/* ✅ Sequence Dropdown below image */}
      <div style={{ marginTop: "1rem" }}>
        <label
          style={{ fontWeight: "600", marginBottom: "6px", display: "block" }}
        >
          Select New Sequence
        </label>
        <select
          className="form-control"
          value={selectedPosition}
          onChange={(e) => {
            setSelectedPosition(Number(e.target.value));
            setError((stateProp) => ({
              ...stateProp,
              positionError: "",
            }));
          }}
          style={{
            width: "100%",
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        >
          <option value="">-- Select Sequence --</option>
          {sequenceOptions.map((sequence) => (
            <option key={sequence} value={sequence}>
              Sequence {sequence}
            </option>
          ))}
        </select>
        {error["positionError"] && (
          <span className="red-color">{error["positionError"]}</span>
        )}
      </div>

      {/* ------Buttons */}
      <div className="button_wrap" style={{ marginTop: "1.5rem" }}>
        <button
          type="button"
          className="button light"
          onClick={addBrandCloseModal}
        >
          Cancel
        </button>
        <button
          type="button"
          ref={buttonLoader}
          onClick={addBannerHandler}
          className="button"
        >
          Submit
        </button>
      </div>
    </CustomModal>
  );
};

export default EditBanner;
